<template lang="html">

    <div class="" v-bind:id="id">
        <p class="has-text-centered pb-4 is-size-4 has-text-weight-bold" :class="classe">REMINDER: {{ data.text }}</p>
    </div>
  
</template>

<script>
export default {
    name: 'bulmaReminder',
    components: {},
    props: {
        id: String,
    },
    data: function () {
      return {}
    },
    watch: {},
    computed: {
        data: function() {
            return this.$store.getters.getObject(this.id).data
        },
        classe() {
            var c = ''
            if(!this.show) c += ' is-hidden'
            if(this.color) c += ' has-text-'+this.color
            return c
        },
        show() {
            var actualState = this.$store.getters.getRecordState
            for(var s of this.data.showState) {
                if(s == actualState) return true
            }
            return false

        },
        color() {
            switch(this.data.color) {
                // case() 
                //     return primary
                case('blue'): 
                    return 'link'
                case('lightblue'): 
                    return 'info'
                case('green'): 
                    return 'success'
                case('yellow'): 
                    return 'warning'
                case('red'): 
                    return 'danger'
                default:
                    return 'danger'
            }
        }
    },
    mounted: function() {},
    methods: {}
  }
</script>